import * as React from "react";

/**
 * Inject a google structured data with a `script` tag.
 *
 * @example
 * <LdJson data={schemaData} />
 */
export function LdJson(props: { data: Record<string, unknown> }) {
	const { data } = props;

	return (
		<script
			dangerouslySetInnerHTML={{
				__html: `(function(){
  const ldJsonScript = document.createElement('script');
  ldJsonScript.setAttribute('type', 'application/ld+json');
  ldJsonScript.textContent = \`${JSON.stringify(data)}\`;
  document.head.appendChild(ldJsonScript);
})();`,
			}}
		/>
	);
}
